"use client"

import { Construction, RefreshCw } from "lucide-react"
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { Button } from "../../components/ui/button"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../components/ui/card"
import { usePlatformStatus } from "../../hooks/api/platform/use-platform"
import { safeGetItem } from "../../lib/utils/localStorage"

const POLL_MS = 30_000

/** Page affichée pendant une maintenance (réponse 503 de l'API) ; se rouvre d'elle-même quand c'est terminé. */
export function MaintenancePage() {
  const navigate = useNavigate()
  const { data, refetch, isFetching } = usePlatformStatus(POLL_MS)
  const maintenance = data?.maintenance

  useEffect(() => {
    if (maintenance && !maintenance.enabled) navigate(safeGetItem("token") ? "/admin/dashboard" : "/auth/login", { replace: true })
  }, [maintenance, navigate])

  const endsAt = maintenance?.ends_at
    ? new Date(maintenance.ends_at).toLocaleString("fr-FR", { weekday: "long", day: "numeric", month: "long", hour: "2-digit", minute: "2-digit" })
    : null

  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md text-center">
        <CardHeader>
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-warning-muted">
            <Construction className="h-8 w-8 text-foreground" />
          </div>
          <CardTitle className="text-2xl">Maintenance en cours</CardTitle>
          <CardDescription className="whitespace-pre-line">
            {maintenance?.message || "Dendromap est momentanément indisponible. Merci de réessayer dans quelques instants."}
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          {endsAt && <p className="text-sm text-muted-foreground">Fin prévue : {endsAt}</p>}
          <p className="text-xs text-muted-foreground">Cette page se rouvre automatiquement dès la fin de la maintenance.</p>
          <Button variant="outline" onClick={() => refetch()} disabled={isFetching}>
            <RefreshCw className="mr-2 h-4 w-4" /> Réessayer
          </Button>
        </CardContent>
      </Card>
    </div>
  )
}
